module.exports = __webpack_public_path__ + "img/logo_weshope_footer.ca53d3d9.png";